module.exports = __webpack_public_path__ + "static/media/save.506a37f2.jpeg";